import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { fadeInAnimation } from '../../_animations/fade-in.animation';
import { NorwaySubmissionSummary } from '../../interfaces/norwaySubmissionSummary.interface';

@Component({
    selector: 'app-norge-confirmation',
    templateUrl: './norge-confirmation.component.html',
    styleUrls: ['../../creditor/creditor-claim-form/creditor-claim-form.component.scss', './norge-confirmation.component.scss'],
    animations: [fadeInAnimation],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NorgeConfirmationComponent {
  public readonly wideSummaryLabelLength = 60;
  public referenceNumber = '';
  public summary: NorwaySubmissionSummary | null = null;
  public isSummaryOpen = false;

  private readonly router = inject(Router);

  constructor() {
    const navigationState = this.router.getCurrentNavigation()?.extras.state ?? history.state;
    this.referenceNumber = navigationState?.referenceNumber ?? '';
    this.summary = navigationState?.summary ?? null;

    if (!this.referenceNumber) {
      this.router.navigate(['/no']);
    }
  }
}
